export const SET_SERVICE_UI_FLAG = 'SET_SERVICE_UI_FLAG';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';
export const SET_SERVICES = 'SET_SERVICES';
export const SET_SERVICE_ITEM = 'SET_SERVICE_ITEM';
export const EDIT_SERVICE = 'EDIT_SERVICE';
export const DELETE_SERVICE = 'DELETE_SERVICE';

